module.exports = __webpack_public_path__ + "static/media/computer-classic.10c1116b.svg";